import React, { useEffect, useState } from "react";
import "../../assets/css/eventsReport.css"
import "bootstrap/dist/css/bootstrap.css";
import { toast } from "react-toastify";
import { getAnalytics, getPageAnalytics ,getMapData } from "../../api/WebpageDashboardApi";
import { Chart } from "react-google-charts"
import Map from './Map'

import { ReactComponent as I1 } from './1.svg';
import { ReactComponent as I2 } from './2.svg';
import { ReactComponent as I3 } from './3.svg';
import { ReactComponent as I4 } from './4.svg';
import { ReactComponent as I5 } from './5.svg';

function Report(props) {
    const [graph, setGraph] = useState([])
    const [noOfDays, setNoOfDays] = useState(7)
    const [noOfDays2, setNoOfDays2] = useState(7)
    const [currGraph, setCurrentGraph] = useState(0)
    const [sGraph, setSGraph] = useState([])
    const [pageData, setPageData] = useState([])

    const [mapPoints , setMapPoints] = useState([])
   const [fitsOn , setFitsOn] = useState([])
    //  const [render,setrender] =useState(false)

    const [showMap , setShowMap] = useState(false)
    const [data, setData] = useState([
        {
            label: "Users",
            selected: true,
            url: "SessionsUsersList",
            value: 0,
            change: 0,
        },
        {
            label: "Sessions",
            selected: false,
            url: "sessionsList",
            value: 0,
            change: 0,

        }, {

            label: "Bounce Rate",
            selected: false,
            value: 0,
            change: 0,

        }, {
            label: "Session Duration",
            selected: false,
            value: 0,
            change: 0,

        },


    ]);
    let CW = null;

    window.addEventListener('resize', function (event) {

        try {
            if (CW) {

                CW.draw()
            }

        } catch (e) {

        }
    }, false);

    useEffect(() => {
        let n1 = sessionStorage.getItem('ER_noOfDays');

        try { n1 = parseInt(n1) } catch (e) { }

        let n2 = sessionStorage.getItem('ER_noOfDays2');

        try { n2 = parseInt(n2) } catch (e) { }

        setNoOfDays(n1 || 7)
        setNoOfDays2(n2 || 7)

        getAnalytics(n1 || noOfDays).then(api => {
            let x = [...data]
            let y = api.analytics
            if (!y)
                return
            x[0].value = y.userCount
            x[0].change = Number(y.userCountChange)

            x[1].value = y.sessionCount
            x[1].change = Number(y.sessionCountChange)

            x[2].value = y.bounceRate
            x[2].change = Number(y.bounceRateChange)

            x[3].value = y.sessionDuration
            x[3].change = Number(y.sessionDurationChange)
            setData(x)
            setGraph(api.graph.reverse())
            setSGraph(getGraphData(currGraph, api.graph))

        })

        getPageAnalytics(n2 || noOfDays).then(api => {
            setPageData(api.pageData)
        })

        getMapData(n1 || 7).then(data=>{
            setMapPoints(MapPointsThic(data.locations))
            setFitsOn(data.fitOn)

        })

        // getPageAnalytics(noOfDays).then(analytics => {
        //     setPageData(analytics)
        // })






    }, [])

    const getGraphData = (i, gg) => {
        let key;
        let header = []
        if (i == 0) {
            key = 'userCount'
            header = ['x', 'users count', 'prev. users count ']
        }

        if (i == 1) {
            key = 'sessionCount'
            header = ['x', 'sessions count', 'prev. sessions count ']
        }

        if (i == 2) {
            key = 'bounceRate'
            header = ['x', 'Bounce rate', 'prev. bounce rate ']
        }

        if (i == 3) {
            key = 'sessionDuration'
            header = ['x', 'session Duration', 'prev. session Duration ']
        }
        let t = graph
        if (gg)
            t = gg

        let g = []
        g.push(header)
        t.forEach(d => {
            g.push([d.date, d.curr ? d.curr[key] : 0, d.prev ? +d.prev[key] : 0])
        })

        return g;
    }

    const handleSelect = (i) => {
        setCurrentGraph(i)
        setSGraph(getGraphData(i))

        let dd = [...data];
        dd.forEach(d => {
            d.selected = false;
        })
        dd[i].selected = true;

        setData(dd);
    }

    const changeNoDays = (i) => {
        sessionStorage.setItem('ER_noOfDays', i);

        setNoOfDays(i)
        getAnalytics(i).then(api => {
            let x = [...data]
            let y = api.analytics
            if (!y) {
                toast.error("No available data through this period ")
                return;
            }

            x[0].value = y.userCount
            x[0].change = Number(y.userCountChange)

            x[1].value = y.sessionCount
            x[1].change = Number(y.userCountChange)

            x[2].value = y.bounceRate
            x[2].change = Number(y.bounceRateChange)

            x[3].value = y.sessionDuration
            x[3].change = Number(y.sessionDurationChange)
            setData(x)
            setGraph(api.graph.reverse())
            setSGraph(getGraphData(currGraph, api.graph))

        })
                getMapData(i).then(data=>{
            setMapPoints(MapPointsThic(data.locations))
                        setFitsOn(data.fitOn)

            
        })
        setNoOfDays(i)


    }
    function MapPointsThic(points){
        if(!points)
            return []
        let all =0;
        points.forEach(p=>{
            all+=p.no
        })

        points.forEach(p=>{
            p.thic = Math.floor((5) + (p.no/all)*3)
            all+=p.no
        })

        return points

    }
    const changeNoDays2 = (i) => {
        sessionStorage.setItem('ER_noOfDays2', i);
        setNoOfDays2(i)
        getPageAnalytics(i).then(api => {
            setPageData(api.pageData)
        })
        setNoOfDays2(i)
    }
    const formatText = (x) => {
        if (x.length > 50)
            return x.substring(0, 50) + "..";
        return x;
    }

    return (
        <div>

            <div className="Rcontainer" >
                

        
                <div className="eBox">
                <div 

                    style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                    }}
                > 

                <div className="web-topbar">
                    <h6>Web Analytics</h6>

                    <div className="wefl">

                
                    <select value={noOfDays} onChange={(e) => { changeNoDays(e.target.value) }} >
                            <option value={7} >Last 7 days</option>
                            <option value={28}>Last 28 days</option>
                            <option value={90}>Last 90 days</option>
                        </select>
                    
                    <div className="web-map">
                        <span style={{borderRight:'0px' , }}   onClick={(e)=>setShowMap(false)}  className={showMap?"klow":"klow klow-sel"} > <span> <I1/> </span> Data</span>
                        <span  className={!showMap?"klow":"klow klow-sel"}  onClick={(e)=>setShowMap(true)}   >  <span><I2/> </span>  Map</span>

                    </div>

                    </div>
                    
                </div>

            
                 </div>
                
                {showMap? <Map mapPoints={mapPoints} fitsOn={fitsOn }/>
                  :<div>
                    <div className="head">

                        {data && data.map((d, i) => {

                            return <>

                            <div className={d.selected ? "we-ite we-ite-selected" : "we-ite"} onClick={() => handleSelect(i)} >
                                <div className="top">
                                    <span>
                                        {d.label}
                                    </span>
                                    {d.url ? <span className="view" onClick={() => props.props.history.push(`/admin/triggersAndEvents/${d.url}?noOfDays=${noOfDays}`)}> <I3/> </span> : ''}
    

                                </div>
                                <div className="bottom">
                                    <span className="ma">
                                        {d.value}
                                    </span>
                                    <span className={d.change >= 0 ? "up" : "down"}>
                                      {  d.change>=0 ?  <I4/> : <I5/> }{d.change} %
                                    </span>
                                </div>

                            </div>
                                {/* <div className="phead">

            


                                    <h6 className={d.selected ? "select selected" : "select"} onClick={() => handleSelect(i)}>
                                        {d.label}
                                    </h6>
                                    <h1 className={d.url ? "num2" : "num"} title="View"
                                        onClick={() =>
                                            d.url ? props.props.history.push(`/admin/triggersAndEvents/${d.url}?noOfDays=${noOfDays}`) : null
                                        }
                                    >
                                        {d.value}
                                    </h1>
                                    <h6 className={d.change >= 0 ? "arrow" : "arrowd"}>
                                        {d.change >= 0 ? "+" : ""} {d.change} {d.change >= 0 ? "%↑" : "%↓"}
                                    </h6>

                                </div> */}
                                {/* {i < data.length - 1 ? <div class="vertical"></div> : ''} */}


                            </>

                        })}

                    </div>

                    <div style={{
                        marginBottom: '10px', zIndex: 0
                    }}>
                        {/* <Line  /> */}
                        {sGraph && sGraph.length > 1 ?
                            <Chart
                                width={'98%'}
                                height={'300px'}
                                chartType="LineChart"
                                loader={<div>Loading Chart</div>}
                                //   rrr = {render}
                                data={sGraph}
                                getChartWrapper={chartWrapper => {
                                    // get a reference to the chartWrapper
                                    CW = chartWrapper
                                    // Redraw when you want
                                    // chartWrapper.draw()
                                }}
                                options={{
                                    legend: { position: 'bottom' },
                                    chartArea: {
                                        // leave room for y-axis labels
                                        width: '88%',
                                        height: '84%',

                                    },

                                    curveType: "function",
                                    colors: ['#1890FF','#2FC25B'],


                                    // series: {
                                    //     1: { lineDashStyle: [1, 2] }
                                    // }

                                }
                                }

                                rootProps={{ 'data-testid': '1' }}
                            /> :
                            <div className="event_conf" >Install Kapitalwise tracking code to monitor website traffic and create automation workflows.
                                <a target="_blank" href="https://kapitalwise.com/user-guide/tags/">Learn more</a>.

                            </div>}
                    </div>



                  </div>}
                                      {/* <div className="horizontal" ></div> */}
              
                
                </div>




                <div className="eBox d" >
                    <div style={{ marginBottom: '40px' }}>
                        <div className="pgtop">
                            <span>Top Pages</span>
                            <select className="wbsel" value={noOfDays2} onChange={(e) => { changeNoDays2(e.target.value) }} >
                            <option value={7} >Last 7 days</option>
                            <option value={28}>Last 28 days</option>
                            <option value={90}>Last 90 days</option>
                        </select>

                        </div>
                        <table className="pageTable">
                            {/* <colgroup>
                                <col span="1" style="width: 15%;">
                                    <col span="1" style="width: 70%;">
                            </colgroup> */}
                            <tbody>
                                <tr style={{ border: 'none' }}>
                                    <th style={{ width: '90%' }}>Page</th>
                                    <th style={{ width: '20%' }}>Pageviews</th>

                                </tr>
                                {
                                    pageData && pageData.map((e, i) => {
                                        return <tr                                            onClick={() => {
                                            let obj = {
                                                webpageUrl: e.webpageUrl,
                                                noOfDays: noOfDays2,
                                                count: e.count

                                            }


                                            props.props.history.push(`/admin/triggersAndEvents/PageViewsList`, obj)

                                        }
                                        }
                                        style={{ cursor: 'pointer' }}
                                        
                                        >
                                            <td><h6 className="wrap" style={{ width: "400px" }}>{e.webpageUrl}</h6></td>
                                            <td
                                            
                                            
                                            >

                                                <h1 className="num2" title="View"
                                                    style={{ fontSize: '12px' }}
         
                                                >{e.count}</h1>

                                            </td>

                                        </tr>
                                    })
                                }
                            </tbody>

                        </table>
                    </div>


                </div>
            </div>
        </div>
    );
}

export default Report;
